// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";
import * as CardThemeType$OrcaPaymentPage from "../Types/CardThemeType.bs.js";
import * as DropdownField$OrcaPaymentPage from "./DropdownField.bs.js";
import * as PaymentTypeContext$OrcaPaymentPage from "../Context/PaymentTypeContext.bs.js";

function PaymentField(props) {
  let __className = props.className;
  let __placeholder = props.placeholder;
  let __type_ = props.type_;
  let __name = props.name;
  let __fieldName = props.fieldName;
  let __rightIcon = props.rightIcon;
  let onBlur = props.onBlur;
  let onChange = props.onChange;
  let value = props.value;
  let setValue = props.setValue;
  let __rightIcon_value = __rightIcon !== undefined ? __rightIcon : null;
  let __fieldName_value = __fieldName !== undefined ? __fieldName : "";
  let __name_value = __name !== undefined ? __name : "";
  let __type__value = __type_ !== undefined ? __type_ : "text";
  let __placeholder_value = __placeholder !== undefined ? __placeholder : "";
  let __className_value = __className !== undefined ? __className : "";
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let config = match.config;
  let match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let themeObj = match$1.themeObj;
  let match$2 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.optionAtom);
  let match$3 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let parentURL = match$3.parentURL;
  let iframeId = match$3.iframeId;
  let loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let isSpacedInnerLayout = config.appearance.innerLayout === "Spaced";
  let contextPaymentType = PaymentTypeContext$OrcaPaymentPage.usePaymentType();
  let paymentType = Core__Option.getOr(props.paymentType, contextPaymentType);
  let elementType = CardThemeType$OrcaPaymentPage.getPaymentModeToString(contextPaymentType);
  let match$4 = React.useState(() => false);
  let setInputFocused = match$4[1];
  let inputFocused = match$4[0];
  let handleFocus = param => {
    setInputFocused(param => true);
    if (setValue !== undefined) {
      setValue(prev => {
        let newrecord = {...prev};
        newrecord.errorString = "";
        newrecord.isValid = undefined;
        return newrecord;
      });
    }
    Utils$OrcaPaymentPage.handleOnFocusPostMessage(iframeId, elementType, parentURL);
  };
  let handleBlur = ev => {
    setInputFocused(param => false);
    if (onBlur !== undefined) {
      onBlur(ev);
    }
    Utils$OrcaPaymentPage.handleOnBlurPostMessage(iframeId, elementType, parentURL);
  };
  let backgroundClass;
  switch (paymentType) {
    case "Payment" :
    case "PaymentMethodsManagement" :
      backgroundClass = themeObj.colorBackground;
      break;
    default:
      backgroundClass = "transparent";
  }
  let direction = __type__value === "password" || __type__value === "tel" ? "ltr" : "";
  let focusClass = inputFocused || value.value.length > 0 ? `mb-7 pb-1 pt-2 ` + themeObj.fontSizeXs + ` transition-all ease-in duration-75` : "transition-all ease-in duration-75";
  let floatinglabelClass = inputFocused ? "Label--floating" : "Label--resting";
  let getClassName = initialLabel => {
    if (value.value.length === 0) {
      return initialLabel + `--empty`;
    }
    let valid = value.isValid;
    if (valid !== undefined) {
      if (valid) {
        return initialLabel + `--valid`;
      } else {
        return initialLabel + `--invalid`;
      }
    } else {
      return "";
    }
  };
  let labelClass = getClassName("Label");
  let inputClass = getClassName("Input");
  let inputLogoClass = getClassName("InputLogo");
  let inputClassStyles = isSpacedInnerLayout ? "Input" : "Input-Compressed";
  let flexDirectionBasedOnType = __type__value === "tel" ? "flex-row" : "flex-col";
  let wrappedOnChange = ev => {
    if (__name_value.length > 0) {
      LoggerUtils$OrcaPaymentPage.logInputChangeInfo(__name_value, loggerState);
    }
    onChange(ev);
  };
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
        condition: __name_value === "phone" && __fieldName_value.length > 0 && config.appearance.labels === "Above" && isSpacedInnerLayout,
        children: JsxRuntime.jsx("div", {
          children: __fieldName_value,
          "aria-hidden": true,
          className: `Label ` + labelClass,
          style: {
            fontSize: themeObj.fontSizeLg,
            fontWeight: themeObj.fontWeightNormal,
            marginBottom: "5px",
            opacity: "0.6"
          }
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
            condition: __type__value === "tel",
            children: JsxRuntime.jsx(DropdownField$OrcaPaymentPage.make, {
              appearance: config.appearance,
              value: Core__Option.getOr(props.valueDropDown, ""),
              setValue: Core__Option.getOr(props.setValueDropDown, param => {}),
              isDisplayValueVisible: true,
              displayValue: Core__Option.getOr(props.displayValue, ""),
              setDisplayValue: Core__Option.getOr(props.setDisplayValue, param => {}),
              fieldName: Core__Option.getOr(props.dropDownFieldName, ""),
              options: Core__Option.getOr(props.dropDownOptions, []),
              width: "w-40 mr-2"
            })
          }),
          JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
            condition: __name_value !== "phone" && __fieldName_value.length > 0 && config.appearance.labels === "Above" && isSpacedInnerLayout,
            children: JsxRuntime.jsx("div", {
              children: __fieldName_value,
              "aria-hidden": true,
              className: `Label ` + labelClass,
              style: {
                fontSize: themeObj.fontSizeLg,
                fontWeight: themeObj.fontWeightNormal,
                marginBottom: "5px",
                opacity: "0.6"
              }
            })
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("input", {
                    ref: Primitive_option.some(props.inputRef),
                    "aria-label": `Type to fill ` + (
                      __fieldName_value.length > 0 ? __fieldName_value : __name_value
                    ) + ` input`,
                    className: inputClassStyles + ` ` + inputClass + ` ` + __className_value + ` focus:outline-none transition-shadow ease-out duration-200`,
                    style: {
                      background: backgroundClass,
                      padding: themeObj.spacingUnit,
                      width: "100%"
                    },
                    autoComplete: "on",
                    disabled: match$2.readOnly,
                    maxLength: props.maxLength,
                    name: __name_value,
                    pattern: props.pattern,
                    placeholder: config.appearance.labels === "Above" || config.appearance.labels === "Never" ? __placeholder_value : "",
                    type: __type__value,
                    value: value.value,
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    onChange: wrappedOnChange
                  }),
                  JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
                    condition: config.appearance.labels === "Floating",
                    children: JsxRuntime.jsx("div", {
                      children: __fieldName_value,
                      "aria-hidden": true,
                      className: `Label ` + floatinglabelClass + ` ` + labelClass + ` absolute bottom-0 ml-3 ` + focusClass + ` pointer-events-none`,
                      style: {
                        fontSize: inputFocused || value.value.length > 0 ? themeObj.fontSizeXs : "",
                        marginBottom: inputFocused || value.value.length > 0 ? "" : themeObj.spacingUnit,
                        opacity: "0.6"
                      }
                    })
                  })
                ],
                className: "relative w-full"
              }),
              JsxRuntime.jsx("div", {
                children: __rightIcon_value,
                className: `InputLogo ` + inputLogoClass + ` relative flex -ml-10  items-center`
              })
            ],
            className: "flex flex-row w-full",
            style: {
              direction: direction
            }
          }),
          JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
            condition: value.errorString.length > 0,
            children: JsxRuntime.jsx("div", {
              children: value.errorString,
              "aria-hidden": true,
              className: "Error pt-1",
              style: {
                alignSelf: "start",
                color: themeObj.colorDangerText,
                fontSize: themeObj.fontSizeSm,
                textAlign: "left"
              }
            })
          })
        ],
        className: `flex ` + flexDirectionBasedOnType + ` w-full`,
        style: {
          color: themeObj.colorText
        }
      })
    ],
    className: "flex flex-col w-full"
  });
}

let make = PaymentField;

export {
  make,
}
/* jotai Not a pure module */
